// extracted by mini-css-extract-plugin
export var active = "_qz-1";
export var circle = "_qz-0";
export var completed = "_qz-2";
export var connector = "_qz-4";
export var connectorCompleted = "_qz-7";
export var connectorSpacer = "_qz-5";
export var iconStrokeOverride = "_qz-8";
export var labelContainer = "_qz-6";
export var pending = "_qz-3";